import React from 'react';
import { Coffee, Lock, Shield } from 'lucide-react';

interface FooterProps {
  onAdminRequest?: () => void;
  onPrivacyRequest?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onAdminRequest, onPrivacyRequest }) => {
  return (
    <footer className="bg-[#1F2933] text-[#F4F1EC] py-20 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-12 text-center md:text-left">
        <div className="max-w-xl">
          <div className="flex items-center justify-center md:justify-start gap-3 mb-6">
            <div className="bg-[#7FAF9A] p-2 rounded-xl text-white shadow-sm">
              <Coffee size={24} />
            </div>
            <span className="text-2xl font-bold tracking-tight">Tiny Systems</span>
          </div>
          <p className="text-[#F4F1EC]/60 leading-relaxed font-medium text-lg">
            We build small, useful AI tools for the world's most innovative home-based solutions.
          </p>
        </div>
        
        <div className="flex flex-col items-center md:items-end gap-6">
          <div className="flex flex-wrap justify-center md:justify-end gap-8">
            <button 
              onClick={onPrivacyRequest} 
              className="text-[#F4F1EC]/40 hover:text-[#7FAF9A] transition-colors flex items-center gap-2 font-bold uppercase tracking-widest text-[10px]"
            >
              <Shield size={12} />
              Privacy Policy
            </button>
            <button 
              onClick={onAdminRequest} 
              className="text-[#F4F1EC]/40 hover:text-[#7FAF9A] transition-colors flex items-center gap-2 font-bold uppercase tracking-widest text-[10px]"
            >
              <Lock size={12} />
              Admin Login
            </button>
          </div>
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-[#F4F1EC]/10">
            © {new Date().getFullYear()} Overpowered Pte. Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
